import { IDataSource } from '~src/datasource/ServerApi/types/IDataSource';

import { FlowOutputStepMapper } from '../../flow/models/mappers/FlowOutputStepMapper';
import { FlowOutputStep } from '../../flow/serverApi/types/FlowOutputStep';
import { LinkedTaskInfo } from '../models/LinkedTaskInfo';
import { LinkedTaskItemInfo } from '../models/LinkedTaskItemInfo';
import { IDataConnection } from '../ServerApi/types/IDataConnection';
import { LinkedTask } from '../ServerApi/types/LinkedTask';
import { INamedItem } from '../ServerApi/types/resourceParts';

export module LinkedTaskMapper {
  export function map(
    linkedTask: LinkedTask,
    flows: _.Dictionary<INamedItem>,
    outputSteps: _.Dictionary<FlowOutputStep>,
    dataConnections: _.Dictionary<IDataConnection>,
    datasources: _.Dictionary<IDataSource>,
  ): LinkedTaskInfo {
    const linkedTaskItems: LinkedTaskItemInfo[] = linkedTask.linkedTaskItems.map((item) => {
      if (!item.linkedTaskContentItem) {
        // If the content item is not found, return null
        return null;
      }
      const outputStepsForTask: FlowOutputStep[] = item.linkedTaskContentItem.flowOutputStepIds.map(id => outputSteps[id]);
      const type: LinkedTaskItemInfo = {
        linkedTaskStepId: item.id,
        id: flows[item.linkedTaskContentItem.targetId].id,
        name: flows[item.linkedTaskContentItem.targetId].name,
        targetId: item.linkedTaskContentItem.targetId,
        isRunAllIncremental: item.linkedTaskContentItem.isRunAllIncremental,
        runAllOutputs: item.linkedTaskContentItem.runAllOutputs,
        flowOutputStepIds: item.linkedTaskContentItem.flowOutputStepIds,
        flowRunSpecOutputStepParamsMap: item.linkedTaskContentItem.flowRunSpecOutputStepParamsMap,
        shouldStopRemainingTasksOnFailure: item.shouldStopRemainingTasksOnFailure,
        shouldAddDataQualityWarning: item.shouldAddDataQualityWarning,
        shouldEnableDataQualityWarningHighVisibility: item.shouldEnableDataQualityWarningHighVisibility,
        userCanEditDataQualityWarning: item.userCanEditDataQualityWarning,
        dataQualityWarningMessage: item.dataQualityWarningMessage,
        stepNumber: item.stepNumber,
        flowOutputSteps: FlowOutputStepMapper.mapForRunFlowTask(
          outputStepsForTask,
          dataConnections,
          item.linkedTaskContentItem.flowRunSpecOutputStepParamsMap,
          item.linkedTaskContentItem.isRunAllIncremental,
          datasources,
        ),
        lastRunAt: item.linkedTaskContentItem.lastRunAt,
        status: item.linkedTaskContentItem.status,
        shouldObfuscate: item.shouldObfuscate,
        subscriptionFlow: item.subscriptionFlow,
        flowParameterParams: item.linkedTaskContentItem.flowParameterParams,
        flowParameters: item.linkedTaskContentItem.flowParameters,
      };
      return type;
    });

    return {
      id: linkedTask.id,
      schedule: { id: linkedTask.scheduleId, name: linkedTask.schedule.name },
      status: null,
      linkedTaskItems: linkedTaskItems,
    };
  }
}
